import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTES, currentConfig } from '@/core/config';
import { updateMetaTags, initializeAnalytics } from '@/shared/services';
import { I18nProvider } from '@/core/i18n';

// Features
import { BurnoutTestPage, ResultsPage } from '@/features/burnout-test';

// Components (Legacy - werden später migriert)
import LandingPage from '@/components/LandingPage';
import EmailCapture from '@/components/EmailCapture';
import PrivacyPolicy from '@/components/PrivacyPolicy';
import TermsOfService from '@/components/TermsOfService';
import About from '@/components/About';
import Contact from '@/components/Contact';
import FAQ from '@/components/FAQ';

function App() {
  useEffect(() => {
    // Initialize analytics
    initializeAnalytics();
    
    // Update meta tags based on current language
    updateMetaTags();
    
    console.log(`App initialized for language: ${currentConfig.language.toUpperCase()}`);
    console.log(`API URL: ${currentConfig.apiUrl}`);
    console.log(`GA Tracking ID: ${currentConfig.gaTrackingId}`);
  }, []);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <I18nProvider>
        <div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-orange-50">
          <Routes>
          <Route path={ROUTES.home} element={<LandingPage />} />
          <Route path={ROUTES.test} element={<BurnoutTestPage />} />
          <Route path={ROUTES.results} element={<ResultsPage />} />
          <Route path={ROUTES.email} element={<EmailCapture />} />
          <Route path={ROUTES.about} element={<About />} />
          <Route path={ROUTES.contact} element={<Contact />} />
          <Route path={ROUTES.faq} element={<FAQ />} />
          <Route path={ROUTES.privacy} element={<PrivacyPolicy />} />
          <Route path={ROUTES.terms} element={<TermsOfService />} />
          </Routes>
          
          {/* Language indicator for development */}
          {process.env.NODE_ENV === 'development' && (
            <div className="fixed bottom-4 right-4 bg-black text-white px-3 py-1 rounded text-sm font-mono">
              {currentConfig.language.toUpperCase()}
            </div>
          )}
        </div>
      </I18nProvider>
    </Router>
  );
}

export default App;
